<template>
    <v-container fluid>
        <v-card class="pa-4">
            <v-card-title class="headline mb-4">
                Добавить параметр биллинга
            </v-card-title>
            <v-card-text>
                <v-form v-model="formValid" @submit.prevent="submitForm">
                    <!-- Вид -->
                    <v-select v-model="selectedBillColumnVid" :items="billColumnVids" @change="onBillColumnVidChange"
                        item-text="name" item-value="id" label="Вид" return-object :rules="[requiredRule]" required
                        class="mb-4"></v-select>

                    <!-- Колонка -->
                    <v-select v-model="selectedBillColumn" :items="billColumnsToDisplay" item-text="name"
                        item-value="id" label="Колонка" return-object :rules="[requiredRule]"
                        :disabled="!selectedBillColumnVid" required class="mb-4"></v-select>

                    <!-- Тариф -->
                    <v-text-field v-model="tarif" label="Тариф (руб)" placeholder="0.00" type="number" step="0.01"
                        :rules="[tarifRule]" class="mb-4" />

                    <!-- Дата начала - в Vue 2 используем v-menu с v-date-picker -->
                    <v-menu v-model="dateMenu" :close-on-content-click="true" transition="scale-transition" offset-y
                        min-width="auto" class="mb-4">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="dateBeginFormatted" label="Дата начала" prepend-icon="mdi-calendar"
                                readonly v-bind="attrs" v-on="on" :rules="[dateRule]" required clearable
                                @click:clear="dateBegin = null"></v-text-field>
                        </template>
                        <v-date-picker v-model="dateBegin" no-title scrollable locale="ru-ru"></v-date-picker>
                    </v-menu>

                    <!-- Кнопки с правильным расположением -->
                    <v-row class="mt-4">
                        <v-col cols="12" class="d-flex justify-end">
                            <v-btn @click="cancel" class="mr-2" color="grey">
                                Отмена
                            </v-btn>
                            <v-btn type="submit" :disabled="!formValid" color="primary">
                                Сохранить
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
export default {
    name: 'AddBillingParameter',
    data() {
        return {
            cargoTypeID: null,
            billColumnVids: [],
            billColumns: [],
            billColumnsToDisplay: [],
            selectedBillColumnVid: null,
            selectedBillColumn: null,
            tarif: null,
            dateBegin: null,
            dateMenu: false,
            formValid: false
        }
    },
    computed: {
        // Форматированная дата для отображения
        dateBeginFormatted() {
            if (!this.dateBegin) return '';

            // Форматируем дату для отображения
            const [year, month, day] = this.dateBegin.split('-');
            return `${day}.${month}.${year}`;
        }
    },
    methods: {
        requiredRule(value) {
            return !!value || 'Это поле обязательно для заполнения';
        },

        tarifRule(value) {
            if (value === null || value === '' || value === undefined) {
                return 'Тариф обязателен для заполнения';
            }
            if (isNaN(value)) {
                return 'Тариф должен быть числом';
            }
            if (parseFloat(value) < 0) {
                return 'Тариф не может быть отрицательным';
            }
            return true;
        },

        dateRule(value) {
            return !!value || 'Дата начала обязательна';
        },

        onBillColumnVidChange() {
            console.log('Selected Vid changed to:', this.selectedBillColumnVid);
            this.updateBillColumnsToDisplay();
            this.selectedBillColumn = null;
        },

        updateBillColumnsToDisplay() {
            if (!this.selectedBillColumnVid || !Array.isArray(this.billColumns)) {
                this.billColumnsToDisplay = [];
                return;
            }

            const selectedVidId = Number(this.selectedBillColumnVid.id);
            this.billColumnsToDisplay = this.billColumns.filter(col => {
                return Number(col.vid) === selectedVidId && !col.isDeleted;
            });
        },

        async submitForm() {
            if (!this.formValid) {
                this.$toast.error('Пожалуйста, заполните все обязательные поля корректно');
                return;
            }

            // Формируем данные для отправки
            const formData = {
                cargoTypeId: this.cargoTypeID,
                idColumn: this.selectedBillColumn.id,
                value: parseFloat(this.tarif),
                dateBegin: this.dateBegin
            };

            console.log('Отправка данных:', formData);
            // this.saveData(formData);
            await this.axios.post(`/Billing/bill-tarif-detal`, formData);

            this.$notify('info', `Данные успешно сохранены`, 5000)

            this.$router.push(`/settings/cargoTypes/BillingParameters/${this.cargoTypeID}`);
        },

        cancel() {
            this.$router.back();
        }
    },
    async created() {
        try {
            this.cargoTypeID = this.$route.params.cargoTypeID;

            // Загружаем виды колонок
            const vidsResponse = await this.axios.get('/billing/bill-column-vids-to-select');
            this.billColumnVids = vidsResponse.data.map(item => ({
                id: Number(item.id),
                name: item.name || 'Не указано'
            }));

            // Загружаем колонки
            const columnsResponse = await this.axios.get('/billing/bill-columns-to-select');
            this.billColumns = columnsResponse.data.map(item => ({
                id: item.id,
                vid: Number(item.vid),
                name: item.name || 'Не указано',
                isDeleted: Boolean(item.isDeleted)
            }));

            this.billColumnsToDisplay = [];

        } catch (error) {
            console.error('Error loading data:', error);
            this.$toast.error('Ошибка загрузки данных');
        }
    }
}
</script>